import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const Blocks = ({
  className,
  color = '#fff',
  width = 24,
  height = 24
}: SVGProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
    >
      <path 
        d="M15 14V2.00001L4.00004 5.9772 4.00001 17.379 15 14Z" 
        fill={color}
      />
      <path 
        d="M17 6.72313V16l-8.99999 2.7646L8 21.379 19 18V6l-2 .72313Z" 
        fill={color}
      />
    </svg>
  );
};
